module.exports = __webpack_public_path__ + "img/chairman.6fd43552.png";